import { Phone, Clock, Loader2 } from "lucide-react";
import { useThirdPartyActive } from "@/lib/third-party";
import { useQuoteForm } from "@/components/QuoteFormContext";

const FORM_SRC = "https://link.systemic-digital.net/widget/form/HY0j326zxDKuZH6dz70Z";
const FORM_MIN_HEIGHT = 600;

/**
 * Hero "Request Your Free Estimate" card.
 *
 * The LeadConnector form iframe pulls in ~3 MB of third-party resources
 * (reCAPTCHA, fonts, tracking), so it is kept out of the initial load. A
 * lightweight placeholder reserves the exact space and the real iframe is
 * swapped in on the first user interaction (see lib/third-party). A button
 * fallback opens the same form in the modal for good measure.
 */
const HeroEstimateForm = () => {
  const active = useThirdPartyActive();
  const { openQuoteForm } = useQuoteForm();

  return (
    <div className="relative rounded-2xl overflow-hidden shadow-premium-lg bg-card p-6 md:p-7 border border-border/60">
      <h2 className="font-heading text-2xl text-foreground mb-1 font-bold">Request Your Free Estimate</h2>
      <p className="text-muted-foreground text-sm mb-4">Fill out the form and we'll respond quickly with clear, honest guidance.</p>

      {active ? (
        <iframe
          src={FORM_SRC}
          style={{ width: "100%", border: "none", borderRadius: "10px", minHeight: `${FORM_MIN_HEIGHT}px` }}
          id="inline-HY0j326zxDKuZH6dz70Z"
          data-layout="{'id':'INLINE'}"
          data-trigger-type="alwaysShow"
          data-trigger-value=""
          data-activation-type="alwaysActivated"
          data-activation-value=""
          data-deactivation-type="neverDeactivate"
          data-deactivation-value=""
          data-form-name="Website Form"
          data-height="746"
          data-layout-iframe-id="inline-HY0j326zxDKuZH6dz70Z"
          data-form-id="HY0j326zxDKuZH6dz70Z"
          title="Website Form"
        />
      ) : (
        <div
          style={{ minHeight: `${FORM_MIN_HEIGHT}px` }}
          className="flex flex-col items-center justify-center gap-4 rounded-[10px] bg-muted/40 border border-border/50 text-center px-6"
        >
          <Loader2 className="h-7 w-7 text-primary motion-safe:animate-spin" aria-hidden="true" />
          <p className="text-muted-foreground text-sm">Loading your secure estimate form…</p>
          <button
            type="button"
            onClick={openQuoteForm}
            className="text-primary font-semibold text-sm underline underline-offset-4 hover:text-primary/80 transition-colors"
          >
            Or request your estimate here
          </button>
        </div>
      )}

      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-muted-foreground text-sm pt-3 border-t border-border/60 mt-3">
        <a href="tel:7863065704" className="flex items-center gap-1.5 font-semibold text-foreground hover:text-primary transition-colors">
          <Phone className="h-4 w-4 text-primary" /> (786) 306-5704
        </a>
        <span className="flex items-center gap-1.5">
          <Clock className="h-4 w-4 text-primary" />
          Mon–Fri 8 AM – 7 PM · Sat 8 AM – 4 PM
        </span>
      </div>
    </div>
  );
};

export default HeroEstimateForm;
